import type { DatasetUploadStatus } from "@/api/datasetUpload";
import type { DiagnosticJobStatus } from "@/api/adminDiagnosticJob";

const labels: Record<DatasetUploadStatus | DiagnosticJobStatus, string> = {
  pending_upload: "파일 전송 대기",
  uploaded: "반입 대기",
  fetching: "파일 가져오는 중",
  probing: "구조 확인 중",
  validating: "검증 중",
  migrating: "변환 중",
  publishing: "반입 중",
  done: "완료",
  failed: "실패",
  duplicate_skipped: "중복 건너뜀",
  conflict: "충돌",
  cancelled: "중단됨",
  queued: "대기 중",
  running: "실행 중",
  cancelling: "중단 요청 중",
  restarting: "재시작 요청 중",
  succeeded: "완료",
  partial_failed: "일부 실패",
};
export function workerJobStatusLabel(status: string): string {
  return labels[status as keyof typeof labels] ?? status;
}
